import { financeRoute } from "./financeRoute";

export const reportRoutes = [...financeRoute];
